"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const initCaseStudySlider = () => {
    const caseStudySliders = $('.caseStudy-slider');
    caseStudySliders.each(function () {
        const caseStudySlider = $(this);
        const buttonsContainer = caseStudySlider.closest('.case-studies').find('.case-studies__buttons');
        const options = {
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            fade: true,
            speed: 150,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        };
        caseStudySlider.slick(options);
        caseStudySlider.closest('.case-studies').on('click', '.arrow-prev', function (e) {
            e.preventDefault();
            caseStudySlider.slick('slickPrev');
        });
        caseStudySlider.closest('.case-studies').on('click', '.arrow-next', function (e) {
            e.preventDefault();
            caseStudySlider.slick('slickNext');
        });
        caseStudySlider.closest('.case-studies').on('click', '.btn-slider', function (e) {
            e.preventDefault();
            const targetSlide = $(this).data('target');
            caseStudySlider.slick('slickGoTo', targetSlide);
            caseStudySlider.slick('slickPlay');
        });
        caseStudySlider.on('afterChange', function (event, slick, currentSlide) {
            const buttonsContainer = caseStudySlider.closest('.case-studies').find('.case-studies__buttons');
            buttonsContainer.find('.btn-slider').removeClass('active');
            buttonsContainer.find(`.btn-slider[data-target="${currentSlide}"]`).addClass('active');
        });
        const addButtons = () => {
            buttonsContainer.empty();
            caseStudySlider.find('.slick-slide').each(function (slideIndex) {
                const slide = $(this);
                const image = slide.find('img');
                const buttonTitle = image.attr('title') || `Case Study ${slideIndex + 1}`;
                const button = $(`<button class="btn-slider" data-target="${slideIndex}">${buttonTitle}</button>`);
                buttonsContainer.append(button);
            });
            buttonsContainer.find('.btn-slider').first().addClass('active');
        };
        addButtons();
    });
};
$(document).ready(() => {
    initCaseStudySlider();
});
